import * as React from 'react'

import { ExternalSchool_externalSchool as ExternalSchool } from 'main/gql/externalSchool'

import {
  AvatarContainer,
  Container,
  Description,
  Legend,
  StyledButton,
  TextContainer,
} from './ClaimAccount.styles'

interface IProps {
  school: ExternalSchool
}

const lego = window.lego

export default function ClaimAccount(props: IProps) {
  const {
    school: { name },
  } = props

  return (
    <Container>
      <TextContainer>
        <Legend>Are you the director of {name}?</Legend>
        <Description muted>
          Claim your account to update information, reach out to interested families, and more!
        </Description>
        <StyledButton
          kind="outline"
          onClick={() => window.open(lego.config.CLAIM_ACCOUNT_URL, '_blank')}
        >
          Claim this account
        </StyledButton>
      </TextContainer>
      <AvatarContainer url={`${lego.config.ASSET_DOMAIN}/images/external-school/claim.png`} />
    </Container>
  )
}
